module.exports = __webpack_public_path__ + "static/media/przystanek.ff9c0e9f.mp4";